export default __webpack_public_path__ + "static/media/pepper.f7c52415.jpg";